export const DART_TIME_LIMIT_MS = 10_000;
export const TURN_RESULT_DELAY_MS = 5000;
